const initState = {
  results: [],
  isLoading: false,
  errorMessage: null,
};

const actionHandlers = {
  REQUEST_CONNECTIONS: (state) => {
    const next = { errorMessage: null, isLoading: true };
    return Object.assign({}, state, next);
  },
  RECEIVE_CONNECTIONS: (state, action) => {
    const next = { results: action.results, isLoading: false };
    return Object.assign({}, state, next);
  },
  REQUEST_CONNECTION: (state) => {
    const next = { errorMessage: null, isLoading: true };
    return Object.assign({}, state, next);
  },
  RECEIVE_CONNECTION: (state, action) => {
    const next = {
      results: state.results.concat(action.results),
      isLoading: false,
    };
    return Object.assign({}, state, next);
  },
  REQUEST_DISCONNECTION: (state) => {
    const next = { errorMessage: null, isLoading: true };
    return Object.assign({}, state, next);
  },
  RECEIVE_DISCONNECTION: (state, action) => {
    const results = state.results.filter(p => p.connectionId !== action.connectionId);
    const next = {
      results,
      isLoading: false,
    };
    return Object.assign({}, state, next);
  },
  SERVICE_ERROR: (state, action) => {
    const next = { errorMessage: action.errorMessage, isLoading: false };
    return Object.assign({}, state, next);
  },
};

export default (kloudlessState = initState, action) => {
  const actionHandler = actionHandlers[action.type];

  return (actionHandler)
    ? actionHandler(kloudlessState, action)
    : kloudlessState;
};



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/kloudlessReducer.js
 **/